// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
'use client'
import { useState } from 'react'

import Card from '@/components/Form/Card'
import Title from '@/components/Form/Title'

import { ConsumerUnitFields } from './'
import { ConsumerUnitProps } from './ConsumerUnit.type'

type RenderUCSProps = {
  id: string
  uc: string
  consumoMedio: string
  grupo: string
  subgrupo: string
  modalidade: string
}

const RenderUCS = ({ id, consumoMedio, uc, grupo, subgrupo, modalidade }: RenderUCSProps) => (
  <div className="flex flex-col border-b py-2">
    <span>
      <b>UC{id}:</b> {uc} (R${consumoMedio}) - {grupo}/{subgrupo} - {modalidade}
    </span>
  </div>
)

const ModalConsumerUnit = ({ formData, onChange, onDelete }: ConsumerUnitProps) => {
  const [ucs] = useState(Array.from({ length: 9 }, (_, index) => ({ id: index + 1 })))
  const [hiddenUcs, setHiddenUcs] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9])

  // Mapeia ucs para listar para o usuário em tela.
  const formattedListUCs = Object.keys(formData.ucs)
    .filter((key) => key.startsWith('Cliente_UC'))
    .map((ucKey) => {
      const id = parseInt(ucKey.replace('Cliente_UC', ''), 10) // Extrai o ID numérico
      const uc = formData.ucs[ucKey]
      const grupo = formData.ucs[`Cliente_Grupo${id}`]
      const consumoMedio = formData.ucs[`Cliente_CM${id}`]
      const subgrupo = formData.ucs[`Cliente_Subgrupo${id}`]
      const modalidade = formData.ucs[`Cliente_MT${id}`]

      return (
        <RenderUCS
          key={id}
          id={id.toString()}
          uc={uc}
          consumoMedio={consumoMedio}
          grupo={grupo}
          subgrupo={subgrupo}
          modalidade={modalidade}
        />
      )
    })

  // Função para limpar os dados de uma UC específica
  const clearUcData = (index: number) => {
    const updatedFormData = { ...formData }

    // Limpa os dados das chaves associadas à UC no formData
    updatedFormData.ucs[`Cliente_UC${index + 1}`] = ''
    updatedFormData.ucs[`Cliente_Grupo${index + 1}`] = ''
    updatedFormData.ucs[`Cliente_CM${index + 1}`] = ''
    updatedFormData.ucs[`Cliente_Subgrupo${index + 1}`] = ''
    updatedFormData.ucs[`Cliente_MT${index + 1}`] = ''

    // Atualiza o formData com os dados limpos
    onDelete(updatedFormData)
  }

  const hiddenUc = () => {
    setHiddenUcs((prevHiddenUcs) => prevHiddenUcs.slice(1))
  }

  return (
    <Card title="Unidades Consumidoras (UC)">
      {/* Botão para Abrir o modal */}
      <button
        type="button"
        className="btn btn-lg mb-2 bg-white"
        onClick={() => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          document.getElementById('ucs_modal')?.showModal()
        }}
      >
        Adicionar Unidades Consumidoras (UC)
      </button>

      {formattedListUCs.length > 0 && (
        <div>
          <h3 className="text-center">UCs informadas ({formattedListUCs.length}):</h3>
          {formattedListUCs}
        </div>
      )}

      {/* Modal Unidades Consumidoras */}
      <dialog id="ucs_modal" className="modal">
        <div className="modal-box max-h-[90vh] w-11/12 max-w-2xl px-10 pb-8">
          {/* Botão X para fechar o modal */}
          <form method="dialog">
            <button className="btn btn-circle btn-ghost btn-sm absolute right-2 top-2">✕</button>
          </form>

          {/* Conteúdo do modal */}
          <Title title="Unidades Consumidoras (UC)" />
          <p className="bold text-center uppercase">
            <strong>Informe os dados da(s) Unidade(s) Consumidora(s).</strong>
          </p>
          <p className="bold text-center uppercase">
            <strong>Você pode informar de uma até nove Unidades Consumidoras (UC).</strong>
          </p>

          <p className="mt-3 text-center">
            Se você possui unidade(s) consumidora(s) em Alta Tensão (AT), informamos que é
            necessário acessar este{' '}
            <a
              href="https://grupobcenergia.com.br/produtos/mercado-livre-de-energia"
              target="_blank"
              rel="noreferrer"
              className="font-bold text-blue-600"
            >
              link
            </a>{' '}
            para realizar o acompanhamento e as ações necessárias
          </p>

          {hiddenUcs.length > 1 ? (
            <button
              type="button"
              className="btn btn-info btn-sm -mt-2 text-white"
              onClick={() => hiddenUc()} // Passa o índice da UC
            >
              Adicionar outra UC
            </button>
          ) : null}

          {/* Lista com os Campos da UC, adicionados dinâmicamente, controlados pelo estado ucs */}
          {ucs.map((uc, index) => (
            <div key={index}>
              <div>
                <ConsumerUnitFields
                  key={index}
                  id={uc.id} // Passa o id único para cada UC
                  formData={formData}
                  onChange={onChange}
                  index={index}
                  clearUcData={clearUcData}
                  hidden={hiddenUcs.includes(index)}
                />
              </div>
            </div>
          ))}
          {/* Botão Salvar. Não salva nada, apenas fecha o modal! */}
          <form method="dialog" className="flex w-full justify-start">
            <button className="text-md btn btn-success m-auto w-[100%] uppercase text-white">
              Salvar UC(s)
            </button>
          </form>
        </div>
      </dialog>
    </Card>
  )
}

export default ModalConsumerUnit
